import React, { useState } from 'react';
import axios from 'axios';
import { Button } from 'antd';
import { ReactComponent as WalletIcon } from './AppleWallet.svg';



const AddToAppleWallet = ({ ticketData }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Check if device is iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const handleAddToWallet = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await axios({
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}generateAppleWalletPass`,
                data: {
                    ticketId: ticketData.ticketId,
                    eventName: ticketData.eventName,
                    location: ticketData.location,
                    datetime: ticketData.datetime,
                    eventId: ticketData.eventId,
                    userId: ticketData.userId
                },
                responseType: 'blob'
            });

            // Create blob URL from response
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ticket.pkpass');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error('Error adding to wallet:', err);
            setError('Unable to add ticket to wallet. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // Don't show the button on non-iOS devices
    // if (!isIOS) {
    //     return null;
    // }

    return (
        <div className="flex flex-col items-center">
            <Button
                
                icon={<WalletIcon width={25} height={25} />}
                onClick={() => handleAddToWallet()}
                className="ticket-btn"
            />

            {error && (
                <div className="mt-2 text-sm text-red-600">
                    {error}
                </div>
            )}
        </div>
    );
};

export default AddToAppleWallet;